(function () {
  if (typeof Bugsnag === 'undefined') return;

  window.__atcFetchTimes = [];

  var origFetch = window.fetch;
  window.fetch = function (url) {
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    var isAtc = urlStr.indexOf('/cart/add') !== -1;
    if (isAtc) {
      var startedAt = Date.now();
      window.__atcFetchTimes.push(startedAt);
      Bugsnag.leaveBreadcrumb('ATC fetch start', { url: urlStr });
      return origFetch.apply(this, arguments)
        .then(function (res) {
          Bugsnag.leaveBreadcrumb('ATC fetch ok', { status: res.status, ms: Date.now() - startedAt });
          return res;
        })
        .catch(function (err) {
          Bugsnag.notify(new Error('ATC fetch threw'), function (ev) {
            ev.addMetadata('atc', {
              url: urlStr,
              ms: Date.now() - startedAt,
              msg: err && err.message,
              ua: navigator.userAgent,
              clarityLoaded: !!window.clarity
            });
          });
          throw err;
        });
    }
    return origFetch.apply(this, arguments);
  };

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('product-form [type="submit"]');
      if (!btn) return;
      var clickedAt = Date.now();
      Bugsnag.leaveBreadcrumb('ATC clicked', { path: window.location.pathname });
      setTimeout(function () {
        var sawFetch = window.__atcFetchTimes.some(function (t) {
          return t >= clickedAt;
        });
        if (!sawFetch) {
          Bugsnag.notify(new Error('ATC silent failure — click, no /cart/add.js in 3s'), function (ev) {
            ev.addMetadata('atc', {
              ua: navigator.userAgent,
              url: window.location.href,
              clarityLoaded: !!window.clarity,
              clarityCookies: document.cookie.indexOf('_clck') !== -1
            });
          });
        }
      }, 3000);
    },
    true
  );
})();
